module.exports = __webpack_public_path__ + "86a986219c69ffd1854f11a2c4444d9d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/add.png
 ** module id = 536
 ** module chunks = 1
 **/